import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { setLoaderStart, setLoaderComplete } from "../../actions/loader/loader";
import { updateUserProfile as mutation } from "../../lib/graphql";
import axios from "axios";
import { loadAccount } from "../../actions/user/account";

export async function submit(values, dispatch) {
    try {
        if (!navigator.onLine) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' })
            return;
        }

        dispatch(setLoaderStart('updateUserProfile'));
        const params = {
            firstName: values?.firstName.trim(),
            lastName: values?.lastName.trim(),
            preferredCurrency: values?.preferredCurrency
        }
        const response = await axios.post('/graphql', {
            query: mutation,
            variables: params
        }, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })


        const { data } = await response?.data

        if (data?.updateUserProfile?.status == 200) {
            await dispatch(loadAccount());
            dispatch(setLoaderComplete('updateUserProfile'));
            await showToaster({ messageId: 'updateProfile', toasterType: 'success' });
        } else {
            dispatch(setLoaderComplete('updateUserProfile'));
            let errorMessage = data?.updateUserProfile?.errorMessage;
            await showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
        }
    } catch (error) {
        return false;
    }
}